import { Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { cyrillicTextValidator } from 'src/app/shared/validators/cyrillic-text.validator';
import { egnValidator } from 'src/app/shared/validators/egn.validator';
import { CustomValidators } from 'ngx-custom-validators';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {

  constructor(private formBuilder: FormBuilder) { }

  /**
   *  Създава форма за адрес
   */
  buildAddressForm() {
    return this.formBuilder.group({
      state: ['', Validators.required],
      city: ['', Validators.required],
      postCode: [''],
      village: ['', cyrillicTextValidator()],
      neighborhood: ['', cyrillicTextValidator()],
      street: ['', [cyrillicTextValidator()]],
      streetNo: [''],
      building: [''],
      entrance: [''],
      floor: [''],
      flat: ['']
    });
  }


  createContactPersonItem() {
    return this.formBuilder.group({
      name: '',
      code: '',
      phone: ''
    });
  }

  createOtherIncomeItem() {
    return this.formBuilder.group({
      name: '',
      amount: ['', CustomValidators.number],
      comment: ''
    });
  }

  createOtherCreditItem() {
    return this.formBuilder.group({
      creditor: null,
      credit: [null, CustomValidators.number],
      payment: [null, CustomValidators.number]
    });
  }

  createGuarantorItem() {
    return this.formBuilder.group({
      egn: ['', [Validators.required, egnValidator(), CustomValidators.digits]],
      firstName: ['', [Validators.required, cyrillicTextValidator()]],
      surname: ['', [Validators.required, cyrillicTextValidator()]],
      lastName: ['', [Validators.required, cyrillicTextValidator()]],
      address: this.buildAddressForm(),
      idCardNo: ['', Validators.required],
      issuedOn: [null, Validators.required],
      mvr: ['', [Validators.required, cyrillicTextValidator()]],
      phoneCode: ['', CustomValidators.digits],
      phone: ['', CustomValidators.digits]

    });
  }


}
